import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Articles.css";
import { getLatestArticles } from './Api';

const LatestArticles = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      const latestArticles = await getLatestArticles();
      setArticles(latestArticles);
    };
    fetchArticles();
  }, []);

  return (
    <section className="latest-articles">
      <div className="article-head">
        <h2 className="article-section-title">Lastest Articles</h2>
        <Link to="/articles"  class="articles-see-all-link">View all articles</Link>
        <Link to="/articles"  class="articles-see-all-link-mobile">View all</Link>
      </div>
      <div className="article-flex">
        {articles.map((article) => (
          <a  className="article-title article-date" href={article.url} target="_blank" rel="noopener noreferrer">
          <div className="article-line"key={article.id}>
            <h3 className="article-title">{article.title}</h3>
            <p className="article-date">{new Date(article.formatted_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}</p>  {/* Use JavaScript to format the date */}
           </div>
           </a>
        ))}
      </div>
    </section>
  );
};

export default LatestArticles;
